<ng-container *ngIf="application$ | async as application; else emptyTemplate">
  <app-modal-header [automaticClose]="false" (closeEvent)="onClose()" class="border-b-2 border-theme-500">
    <div class="flex w-full bg-white">
      <div class="flex">
        <svg-icon class="w-10 text-theme-500" src="assets/icons/icon-gestor-avaliacoes.svg" alt="Materiais Didaticos">
        </svg-icon>
        <h1 class="ml-3 hidden text-sm font-semibold leading-tight text-gray-800 md:grid" translate>
          gestor-avaliacoes.cpb
          <br />
          <b class="text-lg text-black" translate>gestor-avaliacoes.prova</b>
        </h1>
      </div>

      <hr app-modal-divider />

      <div class="flex w-full items-center justify-between">
        <div class="mr-5 grid">
          <span class="text-lg font-semibold leading-tight text-gray-800" translate> gestor-avaliacoes.auditoria </span>
          <div class="grid gap-2 md:flex">
            <div
              class="group/copy flex cursor-pointer"
              app-clipboard
              app-tooltip
              [tooltip]="'geral.copiar' | translate"
              [clipboard]="application?.assessment?.code | uppercase"
            >
              <span class="flex uppercase text-gray-500"> # {{ application?.assessment?.code }} | </span>
            </div>
            <span class="whitespace-pre-wrap uppercase text-gray-500"> {{ application?.assessment?.title }} </span>
          </div>
        </div>
      </div>
    </div>
  </app-modal-header>

  <div app-modal-content class="h-[80vh] w-[98vw] !p-0">
    <div class="overflow-x-auto overflow-y-auto">
      <app-sidenav-group class="!h-[80vh] w-full bg-base-whisper-500 md:!w-[98vw]">
        <ng-template [opened]="true" app-sidenav-start class="rounded-bl-lg">
          <app-sidenav-students></app-sidenav-students>
        </ng-template>
        <ng-template app-sidenav-outer>
          <div class="grid h-auto gap-4 p-5">
            <app-card-student-active></app-card-student-active>
            <div class="flex w-full flex-col justify-between xl:flex-row">
              <app-card-questions
                class="mr-5 grid h-[35vh] w-full overflow-y-auto lg:!h-[77vh] xl:!h-[65vh]"
              ></app-card-questions>

              <app-card-question-active class="mb-5 mt-5 grid h-auto w-full md:mb-0 xl:mt-0"></app-card-question-active>
            </div>
          </div>
        </ng-template>
      </app-sidenav-group>
    </div>
  </div>
</ng-container>

<ng-template #emptyTemplate>
  <div app-modal-content class="h-[80vh] w-[98vw] !p-0">
    <app-skeleton></app-skeleton>
  </div>
</ng-template>
